import React from "react";
import { Link } from "react-router-dom";
import { MEDIA, CONTACT } from "../data/media";
import { useLang } from "../context/LanguageContext";

export const Logo = ({ dark = false, className = "" }) => {
  const { lang } = useLang();
  return (
    <div className={`inline-flex items-center leading-none ${className}`}>
      <Link to="/" data-testid="logo-link" aria-label="Trisé Bistrot">
        <img
          src={MEDIA.logo}
          alt="Trisé"
          className="h-7 md:h-8 w-auto object-contain"
          style={{ filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.15))" }}
        />
      </Link>
      <a
        href={CONTACT.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="logo-booknow"
        className="ml-3 pl-3 border-l border-trise-brass/50 text-[0.6rem] md:text-xs uppercase tracking-[0.42em] text-trise-brass hover:text-trise-terra transition-colors"
      >
        {lang === "it" ? "Prenota" : "Book now"}
      </a>
    </div>
  );
};
